import { createSelector } from 'reselect'
import store from '../../store'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'

// PLOP_APPEND_PATTERN_ANCHOR

export const getSelectedAdAccountTimezone = platform => {
  const { adAccounts } = store.getState()
  const { timezone_name: timezone } = adAccounts.selectedAdAccounts[platform]

  return timezone
}

export const adAccountsSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccounts.results,
  adAccounts => adAccounts
)

export const adAccountsLoadingSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccounts.isLoading,
  isLoading => isLoading
)

export const adAccountsWasLoadedSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccounts.wasLoaded,
  isLoading => isLoading
)

export const selectedAdAccountsSelector = createSelector(
  ({ adAccounts }) => adAccounts.selectedAdAccounts,
  selectedAdAccounts => selectedAdAccounts
)

export const adAccountsWasSelectedSelector = createSelector(
  ({ adAccounts }) => adAccounts.selectedAdAccounts.wasSelected,
  wasSelected => wasSelected
)

export const selectedFacebookAdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.selectedAdAccounts[FACEBOOK_PLATFORM],
  selectedAdAccount => selectedAdAccount
)

export const selectedGoogleAdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.selectedAdAccounts[GOOGLE_PLATFORM],
  selectedAdAccount => selectedAdAccount
)

export const selectedDV360AdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.selectedAdAccounts[DV_360_PLATFORM],
  selectedAdAccount => selectedAdAccount
)

export const selectedTikTokAdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.selectedAdAccounts[TIKTOK_PLATFORM],
  selectedAdAccount => selectedAdAccount
)

// facebook ad account
export const facebookAdAccountIsLoadingSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[FACEBOOK_PLATFORM].isLoading,
  isLoading => isLoading
)

export const facebookAdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[FACEBOOK_PLATFORM].data,
  data => data
)

export const facebookAdAccountWasLoadedSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[FACEBOOK_PLATFORM].wasLoaded,
  wasLoaded => wasLoaded
)

export const facebookAdAccountErrorSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[FACEBOOK_PLATFORM].error,
  error => error
)

// google ad account
export const googleAdAccountIsLoadingSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[GOOGLE_PLATFORM].isLoading,
  isLoading => isLoading
)

export const googleAdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[GOOGLE_PLATFORM].data,
  data => data
)

export const googleAdAccountWasLoadedSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[GOOGLE_PLATFORM].wasLoaded,
  wasLoaded => wasLoaded
)

export const googleAdAccountErrorSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[GOOGLE_PLATFORM].error,
  error => error
)

// dv360 ad account
export const dv360AdAccountIsLoadingSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[DV_360_PLATFORM].isLoading,
  isLoading => isLoading
)

export const dv360AdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[DV_360_PLATFORM].data,
  data => data
)

export const dv360AdAccountWasLoadedSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[DV_360_PLATFORM].wasLoaded,
  wasLoaded => wasLoaded
)

export const dv360AdAccountErrorSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[DV_360_PLATFORM].error,
  error => error
)

// tiktok ad account
export const tikTokAdAccountIsLoadingSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[TIKTOK_PLATFORM].isLoading,
  isLoading => isLoading
)

export const tikTokAdAccountSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[TIKTOK_PLATFORM].data,
  data => data
)

export const tikTokAdAccountWasLoadedSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[TIKTOK_PLATFORM].wasLoaded,
  wasLoaded => wasLoaded
)

export const tikTokAdAccountErrorSelector = createSelector(
  ({ adAccounts }) => adAccounts.adAccount[TIKTOK_PLATFORM].error,
  error => error
)
